import Icon from 'veui/components/Icon'
import { IconHeartSolid } from 'dls-icons-vue'

Icon.register('heart-solid', IconHeartSolid)
